import { BrokenLimitCellType, apiTypesByCellType, shouldHighlightBrokenLimit } from '../utils/brokenLimitUtils';
import { isOutsidePercentageLimit } from './limitInfoUtils';

export type LimitSkin = 'gray' | 'red' | 'amber';

export type LimitConformityInput = {
  adjustedPriceLimitTypes?: string[] | null;
  priceStatus?: string | null;
  price?: number | null;
  suggestedPrice?: number | null;
  retailPrice?: number | null;
  novaMargem?: number | null;
  minMargin?: number | null;
  maxMargin?: number | null;
  novaCompetitividade?: number | null;
  competitorsPrice?: number | null;
  minCpi?: number | null;
  maxCpi?: number | null;
};

const CONFORMABLE_PRICE_STATUSES: readonly string[] = ['ERP', 'AUTO', 'OTIMIZADO'];

/**
 * IT-3358 / RN01: o ambar indica que o motor ajustou o preco pelo limite. Vale para os status que o motor
 * produz (ERP, AUTO, OTIMIZADO); um preco editado nao foi conformado, entao o destaque cai.
 */
const isConformedByLimit = (rowData: LimitConformityInput, type: BrokenLimitCellType): boolean => {
  const { adjustedPriceLimitTypes, priceStatus } = rowData;

  if (!Array.isArray(adjustedPriceLimitTypes)) return false;
  if (!priceStatus || !CONFORMABLE_PRICE_STATUSES.includes(priceStatus)) return false;

  return apiTypesByCellType[type].some(apiType => adjustedPriceLimitTypes.includes(apiType));
};

export const resolveMarginLimitSkin = (rowData: LimitConformityInput): LimitSkin => {
  if (isConformedByLimit(rowData, 'MARGIN')) return 'amber';

  const localBroken = isOutsidePercentageLimit(rowData.novaMargem, rowData.minMargin, rowData.maxMargin);

  return shouldHighlightBrokenLimit({ rowData, localBroken, type: 'MARGIN' }) ? 'red' : 'gray';
};

export const resolveCpiLimitSkin = (rowData: LimitConformityInput): LimitSkin => {
  if (isConformedByLimit(rowData, 'COMPETITIVENESS')) return 'amber';

  const { novaCompetitividade, competitorsPrice, maxCpi, minCpi } = rowData;

  const localBroken =
    !!competitorsPrice &&
    competitorsPrice > 0 &&
    !!novaCompetitividade &&
    !!maxCpi &&
    !!minCpi &&
    (novaCompetitividade > maxCpi * 100 || novaCompetitividade < minCpi * 100);

  return shouldHighlightBrokenLimit({ rowData, localBroken, type: 'COMPETITIVENESS' }) ? 'red' : 'gray';
};
